import { createStore } from "jotai/vanilla";
export const jotaiStore = createStore();
